import React, { useState, useEffect } from "react";
import ShoppingCartPromo from "./shoppingcartpromo";
import "./shoppingcartpromo.scss";
import { ICartContextType, Iprops } from "./shoppingcartpromointerface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { selectors as headerSelector } from "../../../state/features/header";
import { useSelector } from "react-redux";
import partsService from "../../../services/partsservice";
import helperfunctions from "../../../utils/helperfunctions";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { confirmDailog } from "../../ConfirmDailog";
import { useCartContext } from "../shoppingcart";
import { selectors as orderSelector } from "../../../state/features/orderdetail";

function ShoppingCartPromoContainer(props: Iprops) {
    const { isPromoChanges, setIsPromoChanges } = props;
    const { t } = useTranslation();

    const { headercurrentuser, globalData, isMinExpoEnabled,
        enableOrderTracking
    }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
        globalData: globalDataSelector.globaldata(state),
        enableOrderTracking: orderSelector.enableOrderTracking(state),
        isMinExpoEnabled: headerSelector.isMinExpoEnabled(state)
    }));

    const userRoleType = headercurrentuser?.usertype?.name ?? "customer";
    const { isGuestUser }: ICartContextType = useCartContext();

    const [collapseAll, setCollapseAll] = useState(false);
    const [estShipping, setEstShipping] = useState(false);
    const [isPartsCreditOnCheckOut, setIsPartsCreditOnCheckOut] = useState(false);
    const [appliedCreditInfo, setAppliedCreditInfo] = useState<any>({});
    const [applyCreditResponse, setApplyCreditResponse] = useState<any>({ loading: false, data: {} });
    const [selectedCredit, setSelectedCredit] = useState<any>([]);
    const [isPunchOutScreentUrl, setIsPunchOutScreentUrl] = useState({ data: {}, loading: false })
    const { isKomatsuCreditApplied } = props?.itemSummaryDetails?.data ?? {};
    const updateApplyCreditRes = (data: any) => {
        setApplyCreditResponse(data)
    }

    const updateSelectedCredit = (data: any) => {
        setSelectedCredit(data);
    }

    useEffect(() => {
        if (props?.itemSummaryDetails?.data || (isPromoChanges)) {
            onApplyClick({
                ...appliedCreditInfo, total: props?.itemSummaryDetails?.data?.total, appliedCredit: props?.itemSummaryDetails?.data?.komatsuCredit ?? 0
            });
            isPromoCodeChangeUpdate(false)
        }
    }, [props?.itemSummaryDetails?.data, isPromoChanges]);

    const isPromoCodeChangeUpdate = (flg: boolean) => {
        setIsPromoChanges(flg);
    }

    const toggleClick = () => {
        setCollapseAll(!collapseAll);
    };

    const togglePopupClick = () => {
        setEstShipping(!estShipping)
    }

    const ApplyOnClick = (isOpen: boolean, isFromCheckoutButton: boolean = false) => {
        setIsPartsCreditOnCheckOut(isFromCheckoutButton);
        props.setIsApplyCredit(isOpen)
        if (!isOpen && isPartsCreditOnCheckOut) {
            setIsPartsCreditOnCheckOut(false);
            props.CheckoutPageTransfer();
        }
    };

    const partsCreditCancel = (isOpen: boolean) => {
        props.setIsApplyCredit(isOpen);
        updateApplyCreditRes({
            loading: false, data: {}
        });
    };

    const onApplyClick = (creditDetails: any) => {
        setAppliedCreditInfo(creditDetails);
    }

    const onCheckOutClick = () => {
        props.Ordersummaryonclick(komatsuCreditConfirmation);
    };

    const komatsuCreditConfirmation = (checkoutCallback: any) => {
        const userRole = userRoleType?.toLowerCase();
        const isDistributorAdmin = headercurrentuser?.userClaims?.includes("Administration-Distributor-AdminRole");
        const isPartsCreditEnabled = (userRole === 'customer' || (userRole === 'distributor' && isDistributorAdmin) || userRole === 'employee' || userRole === 'company');
        const remainingCredit = props?.customerCreditInfo?.data?.remainingCredit ?? 0;
        if (isPartsCreditEnabled && !isKomatsuCreditApplied && !isGuestUser && remainingCredit > 0) {
            const availableCreditAmount = helperfunctions.formatAmount(props?.customerCreditInfo?.data?.remainingCredit);
            const confimObject = {
                title: t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation),
                message: `${t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation_Msg_Part1)} $${availableCreditAmount} ${t(RESOURCE.MyK_Label_ShoppingCart_Komatsu_Credit_Confirmation_Msg_Part2)}`,
                buttonLabel: {
                    yes: t(RESOURCE.MyK_Label_Yes),
                    no: t(RESOURCE.MyK_Label_No),
                },
                yesOnclick: () => {
                    ApplyOnClick(true, true);
                },
                noOnclick: () => {
                    checkoutCallback();
                },
            };
            confirmDailog(confimObject);
        }
        else {
            checkoutCallback();
        }
        helperfunctions.scrollToTop();
    }

    const openPunchOurScreen = async (punchoutResponseUrl: any) => {
        try {
            if (punchoutResponseUrl) {
                const response = await fetch(punchoutResponseUrl);
                const htmlContent = await response.text();
                const dummyDiv = document.createElement('div');
                dummyDiv.innerHTML = htmlContent;
                document.body.appendChild(dummyDiv);
                const form = dummyDiv.querySelector('form');
                if (form) {
                    form.submit();
                }
            }
        } catch (error) {
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const onCustomerPunchOut = async (reqBody: any) => {
        const response = await partsService.getPunchOutScreenCustomerUrl(reqBody);
        if (response?.isSuccess) {
            setIsPunchOutScreentUrl({ loading: false, data: response?.data ?? {} });
            if (response?.data?.isSuccessful) {
                openPunchOurScreen(response?.data?.punchoutResponseUrl);
            } else {
                helperfunctions.showErrorMessage(`${response?.data?.message}`);
            }
        } else {
            setIsPunchOutScreentUrl({ loading: false, data: {} });
            helperfunctions.showErrorMessage(`${response?.msg}`);
        }
    };

    const onDistributorPunchOut = async (reqBody: any) => {
        const response = await partsService.getPunchOutScreenDistributorUrl(reqBody);
        if (response?.isSuccess) {
            setIsPunchOutScreentUrl({ loading: false, data: response?.data ?? {} });
            if (response?.data?.isSuccessful) {
                if (response?.data?.doFormPost) {
                    openPunchOurScreen(response?.data?.punchoutResponseUrl);
                } else if (response?.data?.punchoutResponseUrl) {
                    window.location.href = response?.data?.punchoutResponseUrl;
                }
            } else {
                helperfunctions.showErrorMessage(`${response?.data?.message}`);
            }
        } else {
            setIsPunchOutScreentUrl({ loading: false, data: {} });
            helperfunctions.showErrorMessage(`${response?.msg}`);
        }
    };

    const navigateToPunchOutScreen = async () => {
        try {
            setIsPunchOutScreentUrl({ data: {}, loading: true });
            const reqBody = {
                punchoutlogrequestid: globalData?.punchOutRequestPartLogId ?? 0,
                cartId: props?.cartsDetails?.cart?.cartId,
                userAadId: headercurrentuser?.azureADId,
            }
            if (props?.isPunchOutDistributorUser) {
                onDistributorPunchOut(reqBody);
            } else {
                onCustomerPunchOut(reqBody);
            }
        } catch (error) {
            setIsPunchOutScreentUrl({ loading: false, data: {} });
            helperfunctions.showErrorMessage(`${error}`);
        }
    };

    const onPunchOutClick = () => {
        navigateToPunchOutScreen();
        helperfunctions.scrollToTop();
    };

    return (
        <ShoppingCartPromo
            showPartCreditWhenPromoApplied={props.showPartCreditWhenPromoApplied}
            togglePopupClick={togglePopupClick}
            itemSummaryDetails={props.itemSummaryDetails}
            collapseAll={collapseAll}
            productRecommendationPopupClick={props.productRecommendationPopupClick}
            toggleClick={toggleClick}
            userRoleType={userRoleType}
            cartsDetails={props?.cartsDetails}
            isCheckoutButton={props?.isCheckoutButton}
            isnextbutton={props?.isnextbutton}
            handelNext={props?.handelNext}
            isActive={props?.isActive}
            ApplyOnClick={ApplyOnClick}
            estShipping={estShipping}
            isapplycredit={props.isApplyCredit}
            getItemSummaryDetails={props.getItemSummaryDetails}
            getCartItems={props?.getCartItems}
            onCheckOutClick={onCheckOutClick}
            customerCreditInfo={props?.customerCreditInfo}
            getCustomerCreditInfo={props?.getCustomerCreditInfo}
            isDisableNext={props?.isDisableNext}
            onApplyClick={onApplyClick}
            appliedCreditInfo={appliedCreditInfo}
            isPromoCodeChangeUpdate={isPromoCodeChangeUpdate}
            updateApplyCreditRes={updateApplyCreditRes}
            applyCreditResponse={applyCreditResponse}
            updateSelectedCredit={updateSelectedCredit}
            selectedCredit={selectedCredit}
            quantityChange={props.quantityChange}
            isPunchOutUser={props?.isPunchOutUser}
            onPunchOutClick={onPunchOutClick}
            isPunchOutScreentUrl={isPunchOutScreentUrl}
            isPlaceOrderButton={props?.isPlaceOrderButton}
            isMinExpoEnabled={isMinExpoEnabled}
            getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading}
            partsCreditCancel={partsCreditCancel}
            onViewDiscountDetails={props?.onViewDiscountDetails}
        />
    );
}

export default ShoppingCartPromoContainer;
